import Vue from './vue/common/vue-common';
import OriginsMenu from './vue/components/origins/OriginsMenu.vue';
import PartnersSustainability from './vue/components/partners/PartnersSustainability.vue';
import cr$ from '../../submodules/src/script/crquery';

export default {
    computed: {
        cr$() {
            return cr$;
        },
    },
    components: { OriginsMenu },
};

new Vue({
    el: '#partners-sustainability',
    components: { 'partners-sustainability': PartnersSustainability },
});

cr$.ready(function () {
    new Vue({
        el: '#origins-menu-vue',
        template: `<OriginsMenu :menu-links='menuLinks' @scroll-to="scrollToAnchor($event)" />`,
        components: { OriginsMenu },
        data() {
            return {
                menuLinks: [
                    {
                        name: 'Impacto Social',
                        anchor: 'quem-faz-roupa',
                    },
                    {
                        name: 'Parceiros',
                        anchor: 'parcerias',
                    },
                    {
                        name: 'Meio Ambiente',
                        anchor: 'meio-ambiente',
                    },
                    {
                        name: 'Transparência',
                        anchor: 'transparencia',
                    },
                ],
            };
        },
        methods: {
            scrollToAnchor(anchor) {
                cr$.byId(anchor).scrollIntoView();
            },
        },
    });
});
